import { render, staticRenderFns } from "./StatusDot.vue?vue&type=template&id=c5aba4e2&scoped=true"
import script from "./StatusDot.vue?vue&type=script&lang=js"
export * from "./StatusDot.vue?vue&type=script&lang=js"
import style0 from "./StatusDot.vue?vue&type=style&index=0&id=c5aba4e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5aba4e2",
  null
  
)

export default component.exports